module.exports = __webpack_public_path__ + "media/right.d3ba8aad.wav";